import { CSSProperties, memo } from "react"
import { useVirtual } from "react-virtual"
import type { Area, GetItemKeyFn } from "./types"
import { styles } from "./styles"

import { GridHeader } from "./GridHeader"
import { GridRow } from "./GridRow"
import { ISortingByColumn } from "models/spots"

export type VirtualOptions = Omit<
  Parameters<typeof useVirtual>[0],
  "keyExtractor"
> & { keyExtractor: GetItemKeyFn }

export type GridProps = {
  area: Area
  virtualOptions: VirtualOptions
  sortingByColumn?: ISortingByColumn
  pagination: boolean
}

export const Grid = memo(function ({
  area = "main",
  virtualOptions,
  sortingByColumn,
  pagination,
}: GridProps) {
  const k = virtualOptions.keyExtractor
  const v = useVirtual(virtualOptions)
  const s = {
    "--grid-height": pagination
      ? "auto"
      : `calc(${v.totalSize}px + var(--header-height))`,
  } as CSSProperties

  return (
    <div data-area={area} className={styles.dataGrid} style={s}>
      <GridHeader area={area} sortingByColumn={sortingByColumn} />
      {v.virtualItems.map((vr) => {
        const id = k(vr.index)
        return (
          <GridRow
            key={area + id}
            id={id}
            index={vr.index}
            start={vr.start}
            area={area}
          />
        )
      })}
    </div>
  )
})
